export default "__VITE_ASSET__fee37caa__"